import SupaBaseModel from "./SupaBaseModel";
import {SupabaseClient} from "./SuperbaseClient";

export default class CareerApplication extends SupaBaseModel {
    static data_name = 'career_applications';

    static newDefault(){
        let instance = new this();
        instance.career_id = null;
        instance.title = "";
        instance.first_name = "";
        instance.last_name = "";
        instance.email = "";
        instance.phone = "";
        instance.date_of_birth = null;
        instance.address = "";
        instance.suburb = "";
        instance.state = "";
        instance.postcode = "";
        instance.country = "";
        instance.vacancy_types = [];
        instance.cv_url = "";
        instance.comment = "";
        instance.source = "";
        instance.other_source = "";
        instance.send_news = false;
        instance.contact_other_positions = false;
        instance.register_job_alerts = false;
        return instance;
    }

    static async paginated(search_text = "", page_index = 0, page_size = 100){
        const start = page_index * page_size;

        let query = SupabaseClient.from(this.data_name)
            .select('*, careers(title, suburb)', { count: 'exact' })
            .order('created_at', { ascending: false });

        const trimmed = (search_text || "").trim();
        if (trimmed.length > 0) {
            const like = `%${trimmed}%`;
            query = query.or(
                `first_name.ilike.${like},last_name.ilike.${like},email.ilike.${like},phone.ilike.${like},comment.ilike.${like}`
            );
        }

        const { data, error, count } = await query.range(start, start + page_size - 1);

        if (error) throw error;

        return {
            count: count || 0,
            results: this.instanceItemsFromData(data || [])
        };
    }

    static async getWithCareer(id){
        const { data, error } = await SupabaseClient.from(this.data_name)
            .select('*, careers(title, suburb, state_id)')
            .eq('id', id)
            .limit(1);

        if(error) throw error;

        return data.length < 1 ? null : this.instanceFromData(data[0]);
    }

    static async signedCVUrl(path, expires_in_seconds = 60){
        const { data, error } = await SupabaseClient.storage.from('career_cvs').createSignedUrl(path, expires_in_seconds);
        if(error) throw error;
        return data.signedUrl;
    }

    static async uploadCV(file){
        const safe_name = (file.name || "cv").replace(/[^a-zA-Z0-9._-]/g, '_');
        const path = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}_${safe_name}`;

        const { error } = await SupabaseClient.storage.from('career_cvs').upload(path, file, {
            cacheControl: '3600',
            upsert: false,
            contentType: file.type || 'application/octet-stream'
        });

        if(error) throw error;

        return path;
    }

    get name(){
        return [this.first_name, this.last_name].filter(p => p && p.length > 0).join(" ");
    }

    get career_title(){
        return this.careers ? this.careers.title : "";
    }

    get career_location(){
        return this.careers ? this.careers.suburb : "";
    }

    get vacancy_types_label(){
        return Array.isArray(this.vacancy_types) ? this.vacancy_types.join(", ") : "";
    }

    get created_at_format(){
        return this.formatDate(this.created_at);
    }

    get date_of_birth_format(){
        return this.date_of_birth ? this.formatDate(this.date_of_birth) : "";
    }
}
